<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">
        
        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Settings</h3>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Settings Tabs -->
        <ul class="nav nav-tabs menu-tabs">
          <li class="nav-item">
            <router-link class="nav-link" to="/settings/profile">
              <i class="fas fa-user mr-2"></i>Profile
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link class="nav-link" to="/settings/security">
              <i class="fas fa-lock mr-2"></i>Security
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/settings/preferences">
              <i class="fas fa-bell mr-2"></i>Preferences
            </router-link>
          </li>
        </ul>

        <!-- Security Form -->
        <div>
          <form @submit.prevent="updatePassword">
            <div class="row">
              <div class="col-lg-9">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title mb-0">Change Password</h5>
                  </div>
                  <div class="card-body">
                    <div class="form-group row">
                      <label class="col-form-label col-md-3">Email</label>
                      <div class="col-md-9">
                        <input 
                          type="text" 
                          class="form-control" 
                          v-model="user.email" 
                          readonly
                        >
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-form-label col-md-3">New Password <span class="text-danger">*</span></label>
                      <div class="col-md-9">
                        <input 
                          type="password" 
                          class="form-control" 
                          v-model="newPassword"
                          placeholder="Enter new password"
                          autocomplete="off"
                          @focus="clearPasswordMatch"
                        >
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-form-label col-md-3">Confirm Password <span class="text-danger">*</span></label>
                      <div class="col-md-9">
                        <input 
                          type="password" 
                          class="form-control" 
                          v-model="confirmNewPassword"
                          placeholder="Confirm new password"
                          autocomplete="off"
                          @focus="clearPasswordMatch"
                        >
                      </div>
                    </div>

                    <div v-if="passwordMatch" class="alert alert-danger">
                      {{ passwordMatch }}
                    </div>
                  </div>
                  <div class="card-footer text-right">
                    <button 
                      type="submit" 
                      class="btn btn-primary"
                      :disabled="!newPassword || !confirmNewPassword || isUpdatingPassword"
                    >
                      <i class="fas fa-key mr-2"></i>
                      {{ isUpdatingPassword ? 'Updating...' : 'Update Password' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import userService from "../../service/user.service";

export default {
  name: "security-settings",
  data() {
    return {
      user: {
        email: null
      },
      newPassword: '',
      confirmNewPassword: '',
      passwordMatch: '',
      isUpdatingPassword: false
    };
  },
  mounted() {
    this.retrieveUser();
  },
  methods: {
    retrieveUser() {
      let user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        this.user.email = user.email;
      }
    },

    updatePassword(event) {
      event.preventDefault();
      
      if (this.newPassword !== this.confirmNewPassword) {
        this.passwordMatch = 'Passwords do not match';
        return;
      }

      if (this.newPassword.length < 6) {
        this.passwordMatch = 'Password must be at least 6 characters long';
        return;
      }

      this.isUpdatingPassword = true;

      userService.changePassword(this.user.email, this.newPassword)
        .then(response => {
          this.isUpdatingPassword = false;
          
          if (response.data.success) {
            this.$swal({
              icon: 'success',
              title: 'Success',
              text: 'Password updated successfully'
            });
            this.newPassword = '';
            this.confirmNewPassword = '';
            this.passwordMatch = '';
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: response.data.narrative || 'Failed to update password'
            });
          }
        })
        .catch(error => {
          this.isUpdatingPassword = false;
          console.error('Error updating password:', error);
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update password'
          });
        });
    },

    clearPasswordMatch() {
      this.passwordMatch = '';
    }
  }
};
</script>

<style scoped>
.card-title {
  color: #667eea;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/SecuritySettings.vue